import { Category } from "./category";
import { Currency } from "./currency";
import { Location } from "./location";
import { Price } from "./price";
import { ProfileImage } from "./profile_image";
import { User } from "./user";

export class Ticket {
  public is_free;
  public purchase_ticket_count: number;
  public ticket_id: string;
  public category: Category;
  public title: string;
  public description: string;
  public event_date: string;
  //public start_date: string;
  public end_date: string;
  public purchase_before_date: string;
  public number_of_tickets: number;
  public number_of_tickets_available: number;
  public price: Price;
  public image: ProfileImage;
  public location: Location;
  public pick_up_address: string;
  public city: string;
  public seller: User;
  public status: number;
  public is_flagged: boolean;
  public flagged_by: User[];
  public fake_count: number;
  public event_url: string;

  // Capture user input
  public category_id: number;
  public currency: string;
  public tempPrice: number;
  public previewImageUrl: string;
  public isCancelled: boolean;
  public unlimitedNoOfTickets: boolean;
  public eventMoreThanOneDay: boolean;
  public isRecurrable: boolean;
  public UnlimitedRecurrable: boolean;
  public recurrableStartDate: string;
  public recurrableEndDate: string;
  public recurrableStartTime: string;
  public recurrableEndTime: string;
  public noOfRecurrance;
}

export type ParsedTicketType = {
  id: number;
  service: string;
  url: string;
  created_at: string;
  last_parse: string;
};



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/model/ticket.ts